module.exports = __webpack_public_path__ + "static/media/productos_cacahuate_crudo.f82622e5.jpg";